import { workSetCheckGroupsAPI } from "@/views/WorkSetCheckGroups/api";

export const getWorkSetCheckGroups = async () => {
  try {
    const res = await workSetCheckGroupsAPI.getList();
    return res
  } catch (e) {}
};

export const addWorkSetCheckGroup = async (body) => {
  try {
    const res = await workSetCheckGroupsAPI.add(body);
    return res;
  } catch (e) {
  }
};

export const updateWorkSetCheckGroup = async (id, body) => {
  try {
    const res = await workSetCheckGroupsAPI.update(id, body);
    return res;
  } catch (e) {
  }
};

export const deleteWorkSetCheckGroup = async (work_set_check_group_id) => {
  try {
    const res = await workSetCheckGroupsAPI.delete(
      work_set_check_group_id
    );
    return res;
  } catch (e) {}
};

export const getGroupsLink = async () => {
  try {
    return await workSetCheckGroupsAPI.getGroupsLink();
  } catch (e) {}
};

export const workSetCheckGroupsColumns = [
  {
    name: "work_set_check_group_id",
    field: "work_set_check_group_id",
    label: "ID",
    align: "center",
  },
  {
    name: "work_set_check_group_name",
    field: "work_set_check_group_name",
    label: "Название",
    align: "center",
  },
  {
    name: "work_set_check_group_code",
    field: "work_set_check_group_code",
    label: "Код группы",
    align: "center",
  },
  {
    name: "order_num",
    field: "order_num",
    label: "Порядок",
    align: "center",
  },
  {
    name: "work_set_check_group_short_name",
    field: "work_set_check_group_short_name",
    label: "Короткое название",
    align: "center",
  },
  {
    name: "stage_id",
    field: "stage_id",
    label: "Этап работ",
    align: "center",
  },
  {
    name: "payment_part",
    field: "payment_part",
    label: "Процент подряда",
    align: "center",
  },
  {
    name: "team_payment_part",
    field: "team_payment_part",
    label: "Процент бригады",
    align: "center",
  },
  {
    name: "company_id",
    field: "company_id",
    label: "Компания",
    align: "center",
  },
  {
    name: "",
    field: "",
    label: "",
    align: "",
  },
    {
    name: "",
    field: "",
    label: "",
    align: "",
  },
];
